import React from "react";
import { PlayModes } from "../../types/PlayModes";
import { format, splitAlbumName } from "../text-helper/text-helper";
import { Link } from "react-router-dom";
import { useMusicStore } from "../store/store";
import { Typography } from "@mui/material";

type PlayModeDisplayProps = {
    mode: PlayModes;
}

const PlayModeDisplay = ({ mode }:PlayModeDisplayProps) => {
    const { currentTrack, genreId, genreName, artistName } = useMusicStore();

    const link = {        
        color: '#ffffff',
        textDecoration: 'none',
    }

    const display = (mode: PlayModes) => {
    switch (mode) {            
        case PlayModes.NoRules:
        case PlayModes.AiGenerated:
        case PlayModes.Similar:
            return "Jukebox";
        case PlayModes.Genre:
            return (
                <Link style={link} to={`/genres/${genreId}`}>
                    {genreName}
                </Link>
            );
        case PlayModes.Artist:
            return (
                <Link style={link} to={`/letters/${currentTrack?.letter}/artists/${currentTrack?.artist}`}>
                    {format(artistName ?? '')}
                </Link>
            );
        case PlayModes.Album:
            return (
                <Link style={link} to={`/letters/${currentTrack?.letter}/artists/${currentTrack?.artist}/albums/${currentTrack?.album}`}>
                    {splitAlbumName(currentTrack?.album ?? '-').title}
                </Link>
            );
        case PlayModes.Track:
            return (
                <Link style={link} to={`/letters/${currentTrack?.letter}/artists/${currentTrack?.artist}/albums/${currentTrack?.album}`}>
                    {currentTrack?.name}
                </Link>
            );
        case PlayModes.Compilation:
            return (
                <Link style={link} to={`/letters/${currentTrack?.letter}/compilations/${currentTrack?.artist}/albums/${currentTrack?.album}`}>
                    {splitAlbumName(currentTrack?.album ?? '-').title}
                </Link>
            );
        case PlayModes.CompilationTrack:
            return (
                <Link style={link} to={`/letters/${currentTrack?.letter}/compilations/${currentTrack?.artist}/albums/${currentTrack?.album}`}>
                    {currentTrack?.name}
                </Link>
            );
        }
    }
    
    return (
        <Typography variant="subtitle2">{display(mode)}</Typography>
    );
}

export default PlayModeDisplay;